import { render } from "./upload-resume-form.vue?vue&type=template&id=296c210a&scoped=true&lang=true"
import script from "./upload-resume-form.vue?vue&type=script&lang=js"
export * from "./upload-resume-form.vue?vue&type=script&lang=js"

import "./upload-resume-form.vue?vue&type=style&index=0&id=296c210a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-296c210a"]])

export default __exports__